export default __webpack_public_path__ + "static/media/069-home.605278d6.svg";